export const spacingStyles = {
	".smartyAddress__spacing_medium": {
		"--smartyAddress__spacingNone": "0px",
		"--smartyAddress__spacingSmall1": "2px",
		"--smartyAddress__spacingSmall2": "5px",
		"--smartyAddress__spacingSmall3": "8px",
		"--smartyAddress__spacingMedium1": "12px",
		"--smartyAddress__spacingMedium2": "17px",
		"--smartyAddress__spacingMedium3": "20px",
		"--smartyAddress__spacingLarge1": "25px",
		"--smartyAddress__spacingLarge2": "32px",
		"--smartyAddress__spacingLarge3": "48px",

		"--smartyAddress__heightLarge1": "500px",
		"--smartyAddress__scrollbarWidth": "thin",
	},
};
